




















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Result } from '@/models/dynamiclist';
import { Getter } from 'vuex-class';

@Component({})
export default class PhonebookResultComponent extends Vue {
    @Prop({ required: true })
    public result!: Result;

    public openMailto(mail: string): void {
        location.href = 'mailto:' + mail;
    }
}
